// This file was auto-generated by Fern from our API Definition.
import * as errors from "./index.js";
export function handleNonStatusCodeError(error, rawResponse, method, path) {
    switch (error.reason) {
        case "non-json":
            throw new errors.AgentaApiError({
                statusCode: error.statusCode,
                body: error.rawBody,
                rawResponse: rawResponse,
            });
        case "body-is-null":
            throw new errors.AgentaApiError({
                statusCode: error.statusCode,
                rawResponse: rawResponse,
            });
        case "timeout":
            throw new errors.AgentaApiTimeoutError(`Timeout exceeded when calling ${method} ${path}.`, {
                cause: error.cause,
            });
        case "unknown":
            throw new errors.AgentaApiError({
                message: error.errorMessage,
                rawResponse: rawResponse,
                cause: error.cause,
            });
        default:
            throw new errors.AgentaApiError({
                message: "Unknown error",
                rawResponse: rawResponse,
            });
    }
}
